import $ from 'jQuery';
import classWithEventsParams from 'libraries/classWithEventsParams';
import main from 'main';

let mod = {};

mod.query = function(parameters)
{
  classWithEventsParams.prototype.init.call(this, parameters);

  // Success status of the query. If the server responds with an error,
  // responds with data jQuery cannot handle or does not respond at all,
  // the query is considered failed and status is set to false.
  this.status = null;

  // XMLHttpRequest object used for the connection.
  this.request = null;

  // The data the server sent us back.
  this.response = null;

  // Callback function to be called after ajax.query has run.
  this.callback = null;
};

mod.query.prototype = new classWithEventsParams();
var fp = mod.query.prototype;

fp.events = {
  'onError': [],
  'onSuccess': [],
  'onComplete': []
};

fp.parameters = {
  events: fp.events,

  // POST or GET request.
  type: 'GET',

   // URL to be queried.
  url: null,

  // The output format the server should respond in.
  outputType: 'json',

  // POST data to be sent to server.
  input: null,

  // By default the request is made asynchronously, i.e. the script does
  // not wait for the request to finish.
  async: true,

  // How the long query waits for an answer from the server?
  timeout: 15000,

  // Default messages.
  defaultMessages: {
    noResponse: 'No response from the server. Maybe the internet connection is down?',
    requestTooLarge: 'Request is too large in size.'
  },

  // Parameters passed directly to jQuery.ajax().
  jQueryAjaxParams: {}
};

// Run query.
fp.run = function(callback)
{
  if(callback)
    this.callback = callback;

  var parent = this;

  // Prefix URL with document.location.href (minus hash if URL begins with
  // ?, & or #.
  var url = (parent.parameters.url.match(/^(\?|&|#)/) ? document.location.href.replace(document.location.hash, '') : '') + parent.parameters.url;

  // Grab and remove hash.
  var hash = url.match(/#+[^#]*$/);
  if(hash && hash[0])
  {
    hash = hash[0];
    url = url.replace(/#+[^#]*$/, '');
  }

  // Add some additional URL parameters.
  url = url +'&output='+ parent.parameters.outputType +'&ajax=1';

  // Replace all question marks with ampersands.
  url = url.replace(/\?/g, '&');

  // Replace first ampersand with a question mark.
  if(!url.match(/\?/))
    url = url.replace(/&/, '?');

  // Put hash back.
  if(hash && hash.length > 0)
    url = url + hash;

  $.ajax(Object.assign({
    type: parent.parameters.type,
    url: url,
    async: parent.parameters.async,
    data: parent.parameters.input,
    dataType: parent.parameters.outputType,
    timeout: parent.parameters.timeout,

    beforeSend: function(request)
    {
      // Grab the XMLHttpRequest object here.
      parent.request = request;
    },

    // Check the content-type header for unexpected types of responses.
    dataFilter: function(data, type)
    {
      var contentType = parent.request.getResponseHeader('Content-Type');

      // If image, display it base64 encoded.
      // Clear body and show the image.
      if(contentType.match(/^image.*/) != null)
        $('body').get(0).innerHTML = '<img src="data:'+ contentType +';base64,'+ data +'" />';

      return data;
    },

    // Request failed. No response from server or server responded with an
    // error header.
    error: function()
    {
      // Get response text and convert it into a JavaScript object. Success
      // method does this automatically.
      let contentType = parent.request.getResponseHeader('Content-Type');
      if(typeof(contentType) === 'string' &&
        contentType.match(/application\/json/) &&
        parent.request.responseText)
        parent.response = $.parseJSON(parent.request.responseText);
      else
        parent.response = parent.request.responseText;

      // Set query status to false.
      parent.status = false;
    },

    // Server responded and there were no error headers.
    success: function(response)
    {
      parent.response = response;

      // Check for errors in server response.
      if(parent.checkErrors())
        parent.status = false;

      // Success.
      else
        parent.status = true;
    },

    // Request completed.
    complete: function()
    {
      parent.complete();
    }
  }, parent.parameters.jQueryAjaxParams))
};

fp.complete = function()
{
  // Run onError callbacks.
  if(!this.status)
    this.runCallbacks('onError', this);

  // Run onSuccess callbacks.
  else if(this.status)
    this.runCallbacks('onSuccess', this);

  // Run onComplete callbacks.
  this.runCallbacks('onComplete', this, this.callback);
};

// Helper method for checking for errors in the server response.
fp.checkErrors = function()
{
  var isErrors = false;

  // Server response was received and successfully parsed.
  if(typeof(this.response) !== 'undefined' && typeof(this.response.messages) !== 'undefined')
  {
    for(var key in this.response.messages)
    {
      if(typeof(this.response.messages[key].type) !== 'undefined' &&
        (this.response.messages[key].type === 'exception' ||
         this.response.messages[key].type === 'error' ||
         this.response.messages[key].type === 'inputError'))
      {
        isErrors = true;
        break;
      }
    }
  }

  return isErrors;
};

// Helper method for getting a message from the server response.
fp.getMessage = function()
{
  var message = null;

  if(typeof(this.response) !== 'undefined' && typeof(this.response.messages) !== 'undefined')
  {
    // If the query failed, try to find an error message.
    if(!this.status)
    {
      for(var key in this.response.messages)
      {
        if(typeof(this.response.messages[key].type) !== 'undefined' &&
          this.response.messages[key].type === 'error' &&
          typeof(this.response.messages[key].message) !== 'undefined')
        {
          message = this.response.messages[key].message;
          break;
        }
      }
    }

    // Just get the first message.
    if(!message)
    {
      for(var key in this.response.messages)
      {
        if(typeof(this.response.messages[key].type) !== 'undefined' &&
          this.response.messages[key].type !== 'exception' &&
          this.response.messages[key].type !== 'inputError' &&
          typeof(this.response.messages[key].message) !== 'undefined')
        {
          message = this.response.messages[key].message;
          break;
        }
      }
    }
  }

  // Query failed and readyState of the request is not 4 (done). We might not
  // be connected to internet. Show the default message.
  else if(!this.status && this.request.readyState !== 4)
  {
    if(typeof(main) !== 'undefined' && typeof(main.framework) !== 'undefined' &&
      typeof(main.framework.dict) !== 'undefined')
      message = main.framework.dict.ajax.defaultResponseNoResponse;
    else
      message = this.parameters.defaultMessages.noResponse;
  }

  else if(!this.status && this.request.status === 413)
  {
    if(typeof(main) !== 'undefined' && typeof(main.framework) !== 'undefined' &&
      typeof(main.framework.dict) !== 'undefined')
      message = main.framework.dict.ajax.defaultResponseRequestTooLarge;
    else
      message = this.parameters.defaultMessages.requestTooLarge;
  }

  // Okay. Return the message.
  return message;
};

export default mod;



// WEBPACK FOOTER //
// ./vendor/kuvio-framework/kustaa/applications/publicFrontend/scripts/libraries/ajax.js